module.exports = __webpack_public_path__ + "static/media/code.38eaa70d.svg";